import React, { cloneElement } from 'react'
import clsx from 'clsx'
import { Grid } from '@mui/material'
import { defaultColumns } from './params'
import { useStyles } from './style'

const List = ({ results, renderItem, columns = defaultColumns }) => {
  const classes = useStyles()
  const cardClassName = clsx(classes.card, columns.lg === 3 && classes.fillColumn)

  return (
    // 16px between cards, the same as the home rails and Featured row
    <Grid container spacing={2} data-test='list-container'>
      {results.map((item, index) => (
        <Grid
          item
          key={item?.friendlyUrl ?? item?.sk ?? index}
          xs={columns.xs}
          sm={columns.sm}
          md={columns.md}
          lg={columns.lg}
          xl={columns.xl}
          data-test={`list-item-${index}`}
        >
          {cloneElement(renderItem(item, index), { className: cardClassName })}
        </Grid>
      ))}
    </Grid>
  )
}

export default List
